// removed by extract-text-webpack-plugin
module.exports = {"Pricing":"_3x8IskkUgInqllm0t9MH7Z"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/forms/fieldsets/ShortTicketFieldset.scss
// module id = 1457
// module chunks = 0